import { render } from "./Notifications.vue?vue&type=template&id=6e5135d6&scoped=true"
import script from "./Notifications.vue?vue&type=script&setup=true&lang=js"
export * from "./Notifications.vue?vue&type=script&setup=true&lang=js"

import "./Notifications.vue?vue&type=style&index=0&id=6e5135d6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e5135d6"],['__file',"src/components/header/Notifications.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e5135d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e5135d6', __exports__)) {
    api.reload('6e5135d6', __exports__)
  }
  
  module.hot.accept("./Notifications.vue?vue&type=template&id=6e5135d6&scoped=true", () => {
    api.rerender('6e5135d6', render)
  })

}


export default __exports__